export default {
  app: {
    name: "EpicPH Back Office",
    full: "EpicPH Back Office",
    minimized: "EPBO"
  },
  welcome: "Welcome back, {user}!",
  login: "Sign In to your account",
  relogin: "Please re-login to your account again.",
  expired: "Session Expired!",
  denied: "Permission Denied!",
  success: "You have successfully completed!",
  search_by_id_name: "Search by ID or Name",
  search_by_id: "Search by ID",
  search_by_full_id: "Search by full ID",
  change_user_status_confirm: "Are you sure you want to change the Account Status?",
  delete_confirm: "Are you sure you want to delete \"{name}\"",
  successful_change_password: "You have successfully change password.",
  change_disable_confirm: "Are you sure you want to change \"{name}\" to disable?",
  select_option: "Select your option",
  no_data_available: "No Data Available",
  no_rating_available: "No Rating Available",
  successful_update_security: "You have successfully update security.",
  successful_disable_security: "You have successfully disable security.",
  update_security_confirm: "Are you sure you want to update security?",
  disable_security_confirm: "Are you sure you want to disable security?",
  change_operator_status_confirm: "Are you sure you want to change operator \"{name}\" status?",
  change_member_status_confirm: "Are you sure you want to change member \"{name}\" status?",
  approve_ticket_confirm: "Are you sure you want to approve the ticket?",
  reject_ticket_confirm: "Are you sure you want to reject the ticket?",
  change_self_operate_confirm: "Are you sure you want to change \"{name}\" operation mode?",
  change_bank_account_status_confirm: "Are you sure want to change \"{name}\" account status?",
  change_ibank_account_status_confirm: "Are you sure want to change \"{name}\" account status?",
  change_promo_status_confirm: "Are you sure want to change \"{name}\" promotion status?",
  change_promo_signup_status_confirm: "Are you sure want to change \"{name}\" promotion signup status?",
  knock_off_promo_confirm: "Are you sure you want to knock off \"{name}\" promotion?",
  successful_promo_package_download: "You have successfully download promotion package.",
  successful_update_account_setup: "You have successfully update account setup.",
  unblock_member_confirm: "Are you sure you want to unblock member \"{name}\"?",
  unblock_operator_confirm: "Are you sure you want to unblock operator \"{name}\"?",
  block_sub_account_confirm: "Are you sure you want to block sub account \"{name}\"?",
  unblock_sub_account_confirm: "Are you sure you want to unblock sub account \"{name}\"?",
  successful_create_secondary_account: "You have successfully create secondary account.",
  update_account_password_confirm: "Are you sure you want to update account password?",
  successful_update_account_password: "You have successfully update account password.",
  update_account_password_cancel: "Are you sure you want to cancel update account password?",
  change_affiliate_status_confirm: "Are you sure you want to change affiliate \"{name}\" status?",
  approve_affiliate_confirm: "Are you sure you want to approve \"{name}\" as affiliate?",
  unblock_affiliate_confirm: "Are you sure you want to unblock affiliate \"{name}\"?",
  change_coupon_status_confirm: "Are you sure want to change \"{name}\" coupon status?",
  submit_acknowledgement_confirm: "Are you sure want to submit acknowledgement?",
  change_bank_group_default_confirm: "Are you sure want to set \"{name}\" as default bank group?",
  change_withdrawal_limit_default_confirm: "Are you sure want to set \"{name}\" as default withdrawal limit?",
  change_promotion_group_default_confirm: "Are you sure want to set \"{name}\" as default promotion group?",
  change_referral_status_confirm: "Are you sure you want to change \"{name}\" referral status?",
  change_withdrawal_limit_confirm: "Are you sure you want to change \"{name}\" withdrawal limit?",
  change_promotion_group_confirm: "Are you sure you want to change \"{name}\" promotion group?",
  change_bank_group_confirm: "Are you sure you want to change \"{name}\" bank group?",
  change_member_bet_limit_confirm: "Are you sure you want to change \"{name}\" \"{provider}\" bet limit?",
  assign_free_credit_confirm: "Are you sure want to assign free credit to \"{name}\"?",
  update_survey_status_confirm: "Are you sure you want to update survey status?",
  move_banner_up_confirm: "Are you sure want to move banner \"{name}\" up?",
  move_banner_down_confirm: "Are you sure want to move banner \"{name}\" down?",
  delete_banner_confirm: "Are you sure want to delete banner \"{name}\"?",
  change_banner_status_confirm: "Are you sure you want to change banner \"{name}\" status?",
  delete_page_confirm: "Are you sure want to delete page \"{name}\"?",
  change_page_status_confirm: "Are you sure you want to change page \"{name}\" status?",
  clear_maintenance_time_confirm: "Are you sure want to clear \"{name}\" maintenance time?",
  successful_clear_outstanding: "You have successfully clear {amt} outstanding amount.",
  clear_outstanding_confirm: "Are you sure want to clear \"{name}\" outstanding?",
  trace_outstanding_confirm: "Are you sure want to trace \"{name}\" outstanding?",
  change_setting_confirm: "Are you sure want to change \"{name}\" setting?",
  add_bonus_list_member_confirm: "Are you sure want to add selected member to bonus list?",
  delete_bonus_list_member_confirm: "Are you sure want to delete selected member from bonus list?",
  delete_ip_address_confirm: "Are you sure want to delete ip \"{ip}\" under \"{name}\"?",
  add_ip_address_confirm: "Are you sure want to add ip \"{ip}\" under \"{name}\"?",
  change_payment_mode_status_confirm: "Are you sure want to change \"{name}\" payment mode status?",
  change_provider_group_status_confirm: "Are you sure want to change \"{group}\" status under \"{mode}\"?",
  bulk_issue_bonus_member_confirm: "Are you sure want to issue bonus to members in bonus list?",
  change_provider_group_recommend_confirm: "Are you sure want to change \"{group}\" recommend under \"{mode}\"?",
  change_provider_group_seq_confirm: "Are you sure want to change \"{group}\" sequence under \"{mode}\"?",
  no_member_found: "No Member Found",
  redeposit_ticket_confirm: "Are you sure want to redeposit ticket?",
  change_provider_group_limit_confirm: "Are you sure want to change \"{group}\" limit under \"{mode}\"?",
  audit_ticket_confirm: "Are you sure you want to audit the ticket?",
  review_ticket_confirm: "Are you sure you want to review the ticket?",
  change_promotion_group_seq_confirm: "Are you sure want to change \"{promotion}\" sequence under \"{group}\"?",
  unlock_custom_vip_confirm: "Are you sure want to unlock \"{name}\" custom vip?",
  move_affiliate_confirm: "Are you sure want to move whole branch of \"{name}\" direct under company?",
  cancel_unfinish_round_confirm: "Are you sure want to cancel unfinish round \"{round}\"?",
  change_payment_mode_seq_confirm: "Are you sure want to change \"{mode}\" sequence?",
  remove_bank_default_provider_confirm: "Are you sure want to remove \"{bank}\" default provider?",
  change_label_status_confirm: "Are you sure want to change \"{name}\" label status?",
  clear_iframe_url_confirm: "Are you sure want to clear iframe url?",
  adjust_balance_remark: "Support minus sign (-) to deduct balance from member wallet",

  change_vip_default_confirm: "Are you sure want to change \"{name}\" to default VIP?",
  move_vip_confirm: "Are you sure want to change \"{name}\" to position \"{position}\"?",
  delete_turnover_tier_confirm: "Are you sure want to delete \"{name}\" turnover tier?",
  vip_provider_rebate_batch_confirm: "Are you confirm to proceed with vip provider rebate batch update?",
  copy_rebate_rate_all_confirm: "Are you sure want to copy \"{name}\" of \"{provider}\" to all providers?",
  edit_vip_confirm: "Are you want to update rebate rate of \"{name}\"?",
  add_promotion_custom_member_confirm: "Add you want to add promotion custom member list?",
  delete_promotion_custom_member_confirm: "Add you want to delete \"{name}\" promotion custom member list?",
  change_rescue_fund_status_confirm: "Are you sure want to change \"{name}\" rescue fund status?",
  add_rescue_fund_custom_member_confirm: "Add you want to add rescue_fund custom member list?",
  delete_rescue_fund_custom_member_confirm: "Add you want to delete \"{name}\" rescue_fund custom member list?",

  delete_game_exclude_confirm: "Are you sure want to delete game \"{name}\" under \"{provider}\"?",
};
